import { Clipboard } from '@angular/cdk/clipboard';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { clone } from 'lodash';
import { SubSink } from 'subsink';

import { BaseScriptFragment } from '../../../generated/graphql.generated';
import { HistoryService } from '../../history/history.service';
import { DetailsHelperService } from '../../services/details-helper.service';
import { FreyaNotificationsService } from '../../services/freya-notifications.service';
import { PermissionService } from '../../services/permission.service';
import { parseMenuItemCategoriesVisible } from '../../utilities/menu-item.util';
import { MutateScriptComponent } from '../mutate-script/mutate-script.component';

@Component({
	selector: 'app-script-details',
	templateUrl: './script-details.component.html',
	styleUrls: ['./script-details.component.scss'],
})
export class ScriptDetailsComponent implements OnInit, AfterViewInit, OnDestroy {

	@Input() script: BaseScriptFragment;
	@ViewChild('mutate') mutateRef: MutateScriptComponent;

	subs = new SubSink();

	updateAction = {
		label: 'Edit',
		icon: 'pi pi-pencil',
		visible: false,
		command: () => this.openUpdate(),
	};

	viewHistoryAction = {
		id: 'viewHistory',
		label: 'View History',
		icon: 'pi pi-book',
		visible: true,
		command: () => this.historyService.openHistory('Script', [this.script.id]),
	};

	scriptActions = [{
		label: 'Actions',
		items: [
			this.updateAction,
			this.viewHistoryAction,
		],
		visible: false,
	}];

	constructor(
		private detailsHelper: DetailsHelperService,
		private permissionHandler: PermissionService,
		private clipboard: Clipboard,
		private localNotify: FreyaNotificationsService,
		private historyService: HistoryService,
	) {}

  ngOnInit(): void {
		this.subs.sink = this.detailsHelper.detailsItem.subscribe((item) => {
			if (item?.type !== 'scripts') { return; }
			this.script = item.item;
		});

		this.subs.sink = this.permissionHandler.watchPermissions(
			['scripts.update', 'history.list'])
			.subscribe((res) => {
				this.updateAction.visible = res[0];
				this.viewHistoryAction.visible = res[1];

				const [actions] = this.scriptActions;
				actions.visible = actions.items.some((a) => a.visible);

				parseMenuItemCategoriesVisible(this.scriptActions);
				this.scriptActions = clone(this.scriptActions);
			});
	}

	ngAfterViewInit(): void {
		// @ViewChild queries resolve after the view is initialised, so wire up
		// the mutate dialog's saved event here rather than in ngOnInit.
		this.subs.sink = this.mutateRef.saved.subscribe((updated) => {
			if (updated?.id === this.script?.id) {
				this.script = updated;
			}
		});
	}

	ngOnDestroy() {
		this.subs.unsubscribe();
	}

	openUpdate() {
		this.mutateRef.openDialog(this.script, 'update');
	}

	getSourceType(): 'url' | 'inline' | 'none' {
		if (this.script?.scriptUrl) { return 'url'; }
		if (this.script?.code) { return 'inline'; }
		return 'none';
	}

	getSourcePreview(): string {
		if (this.script?.scriptUrl) {
			return this.script.scriptUrl;
		}
		if (this.script?.code) {
			const code = this.script.code;
			if (code.length <= 200) { return code; }
			return code.slice(0, 200) + '...';
		}
		return '';
	}
}